import { render, staticRenderFns } from "./HistorialEstado.vue?vue&type=template&id=6fb9e3b7"
import script from "./HistorialEstado.vue?vue&type=script&lang=js"
export * from "./HistorialEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports